import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "@/views/LoginView.vue";


Vue.use(VueRouter)

const routes = [

  
  //fichajes
  {
    path: '/',
    name: 'Fitxajeak',
    component: () => import(/* webpackChunkName: "fichajes" */ '@/views/HomeView.vue'),
    meta:{
      requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Home',
            content: 'Página principal de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
  

    
    //lanorduak
    {
      path: '/hours',
      name: 'Orduak',
      component: () => import(/* webpackChunkName: "lanoorduak" */ '@/views/HoursView.vue'),
      meta:{
        requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Hours',
            content: 'Página control de horas trabajadas de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },

    //vacaciones
    {
      path: '/calendar',
      name: 'Egutegia',
      component: () => import(/* webpackChunkName: "vacaciones" */ '@/views/CalendarView.vue'),
      meta:{
        requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Calendar',
            content: 'Página de calendario de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
    
    //konfigurazioa
    {
      path: '/config',
      name: 'Konfigurazioa',
      component: () => import(/* webpackChunkName: "login" */ '@/views/ConfigView.vue'),
      meta:{
        requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Configuracion',
            content: 'Página de configuracion de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
    
    //login
      {
        path: '/login',
        name: 'Login',
        component:LoginView,
        meta:{
          title: process.env.VUE_APP_TITLE,
          metaTags: [
            {
              name: 'Login',
              content: 'Página de login de la app para ' + process.env.VUE_APP_COMPANY
            },
          ]
        }
      },
  ]
  
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
  
  
  router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('token')
    
    // console.log("Es adminnnnnnnnnnnnn: "+is_admin);
    const pageTitle = to.meta.title
    if (pageTitle){
    document.title = pageTitle
  } 
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    console.log('not logged in')
    next({name:'Login'})
  } else {

    if (loggedIn ? to.path !== '/login' : true) next();
  }
})

export default router
